import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useState } from 'react';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntities as getMaintenanceModels } from 'app/entities/maintenance-model/maintenance-model.reducer';
import { PartSelectionModal } from 'app/modules/part/PartSelectionModal';
import { extractIds } from 'app/shared/util/functions-util';
import { createEntity, getEntity, reset, updateEntity } from './maintenance-review.reducer';
import SelectPaginate from 'app/shared/components/select-paginate/SelectPaginate';
import { IMaintenanceModel } from 'app/shared/model/maintenance-model.model';
import { toast } from 'react-toastify';

export const MaintenanceReviewUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);
  const [selectedParts, setSelectedParts] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [maintenanceModel, setMaintenanceModel] = useState<IMaintenanceModel>(null);

  const maintenanceReviewEntity = useAppSelector(state => state.maintenanceReview.entity);
  const loading = useAppSelector(state => state.maintenanceReview.loading);
  const updating = useAppSelector(state => state.maintenanceReview.updating);
  const updateSuccess = useAppSelector(state => state.maintenanceReview.updateSuccess);

  const handleClose = () => {
    props.history.push('/maintenance-review' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (maintenanceReviewEntity?.parts?.length && !isNew) {
      setSelectedParts(maintenanceReviewEntity?.parts);
    }
  }, [maintenanceReviewEntity]);

  useEffect(() => {
    if (maintenanceReviewEntity?.maintenanceModel?.id) {
      setMaintenanceModel(maintenanceReviewEntity.maintenanceModel);
    }
  }, [maintenanceReviewEntity]);

  const defaultValues = () =>
    !isNew && {
      ...maintenanceReviewEntity,
      parts: getSelectedPartsMessage(),
    };

  const getSelectedPartsMessage = useCallback(() => {
    return selectedParts && selectedParts.length ? `${selectedParts.length} ${selectedParts.length > 1 ? 'peças selecionadas' : 'peça selecionada'}` : '';
  }, [selectedParts]);

  const saveEntity = values => {
    const entity = {
      ...maintenanceReviewEntity,
      ...values,
      parts: extractIds(selectedParts),
      maintenanceModel,
    };

    if (!entity.maintenanceModel) {
      return toast.error('Selecione um modelo de manutenção.');
    }

    if (!entity?.parts?.length) {
      return toast.error('Selecione ao menos uma peça.');
    }

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  useEffect(() => {
    setMaintenanceModel(null);
    setSelectedParts([]);
  }, []);

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.maintenanceReview.home.createOrEditLabel" data-cy="MaintenanceReviewCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.maintenanceReview.home.createOrEditLabel">Create or edit a MaintenanceReview</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  hidden
                  name="id"
                  required
                  readOnly
                  id="maintenance-review-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.maintenanceReview.reviewOrder')}
                id="maintenance-review-reviewOrder"
                name="reviewOrder"
                data-cy="reviewOrder"
                type="number"
                required
              />
              <ValidatedField
                label={translate('fleetSenseApp.maintenanceReview.km')}
                id="maintenance-review-km"
                name="km"
                data-cy="km"
                type="number"
                required
              />
              <ValidatedField
                label={translate('fleetSenseApp.maintenanceReview.period')}
                id="maintenance-review-period"
                name="period"
                data-cy="period"
                type="number"
              />
              {/*
              <ValidatedField label={translate('fleetSenseApp.maintenanceReview.hour')} id="maintenance-review-hour" name="hour" data-cy="hour" type="number" />
              */}
              <ValidatedField
                label={translate('fleetSenseApp.maintenanceReview.description')}
                id="maintenance-review-description"
                name="description"
                data-cy="description"
                type="textarea"
              />
              <div className="mb-3 mt-3">
                <label data-tip data-for="maintenanceModel">
                  {translate('fleetSenseApp.truckImplement.maintenanceModel')}
                </label>
                <SelectPaginate
                  apiUrl="api/maintenance-models/by-company"
                  placeholder=""
                  searchName="nameSearch"
                  onChange={setMaintenanceModel}
                  value={maintenanceModel}
                  valueName="name"
                />
              </div>
              <ValidatedField
                label={translate('fleetSenseApp.maintenanceReview.part')}
                id="maintenance-review-part"
                data-cy="part"
                name="parts"
                style={{ cursor: 'pointer' }}
                onClick={() => setModalOpen(true)}
                value={getSelectedPartsMessage()}
              />
              <PartSelectionModal modalOpen={modalOpen} selectedParts={selectedParts} setModalOpen={setModalOpen} setSelectedParts={setSelectedParts} />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/maintenance-review" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MaintenanceReviewUpdate;
